import React, { useState } from "react";
import plusIcon from "../icons/bx-plus.svg";
import minusIcon from "../icons/bx-minus.svg";
import environment, { updateLocalSetting } from "../Environment";
import { useTheme } from "../contexts/ThemeContext";
import "./TreeItem.css";

function TreeNodeFolder(props) {
    let treeLocalValue = localStorage.getItem("Settings.treeStates");
    let treeLocalValueObj = JSON.parse(JSON.parse(treeLocalValue)) || {};
    // console.log(treeLocalValueObj);
    let treeStateData = treeLocalValueObj;
    let nodeState = treeStateData[props.id];
    // console.log(nodeState);
    const [isCollapsed, setIsCollapsed] = useState(nodeState);
    const theme = useTheme();

    const iconOnClick = (e) => {
        e.preventDefault();
        treeStateData[props.id] = !isCollapsed;
        let treeStateDataString = JSON.stringify(treeStateData);
        updateLocalSetting("treeStates", treeStateDataString);
        let treeLocalValue = localStorage.getItem("Settings.treeStates");
        let treeLocalValueObj = JSON.parse(JSON.parse(treeLocalValue));
        setIsCollapsed(
            treeLocalValueObj[props.id] || treeLocalValueObj[props.id] == null
        );
    };

    let iconState = isCollapsed ? "true" : "false";

    return (
        <div>
            <div className="btn-parent-node">
                <span className="folder-container">
                    {isCollapsed ? (
                        <img
                            onClick={iconOnClick}
                            className={`img-toggle`}
                            src={plusIcon}
                            alt=""
                        />
                    ) : (
                        <img
                            onClick={iconOnClick}
                            className={`img-toggle img-toggle-${iconState}`}
                            src={minusIcon}
                            alt=""
                        />
                    )}
                    <div
                        data-id={props.id}
                        data-name={props.name}
                        onClick={props.onFolderClick}
                        className={`folder-name theme-${theme.foreground}`}
                    >
                        {props.name}
                    </div>
                </span>
            </div>
        </div>
    );
}

export default TreeNodeFolder;
